<template>
<div class="row">
  <div class="col-md-12">
    <div class="card vx-card">
      <div class="card-body" v-loading="loading">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <!-- <h4 class="font-weight-bold">Lista de artículos</h4> -->
            <registers-per-page @changeNumPerPage="changeNumPerPage"></registers-per-page>
            <search-filter @executeSearch="search" :options="[]"></search-filter>
          </div>
          <div class="col-md-4 text-center" v-if="!loading && items.length > 0">
            <p>Cantidad en inventario: {{ inventory.quantity }} </p>
          </div>
          <vs-button type="gradient" @click="newItem()">
            <i class="fa fa-plus"></i>
            Nuevo ingreso inventario
          </vs-button>
        </div>

        <div id="data-list-list-view" class="data-list-container mt-5" v-if="items.length">
            <vs-table ref="table" :max-items="perPage" :data="items">
              <template slot="thead">
                <vs-th>Proveedor</vs-th>
                <vs-th>Cantidad</vs-th>
                <vs-th>Fecha</vs-th>
                <vs-th>Hora</vs-th>
                <vs-th>Factura</vs-th>
                <vs-th>Tipo</vs-th>
                <vs-th>Acciones</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td>
                      {{ item.provider.name }}
                    </vs-td>
                    <vs-td>
                      {{ item.quantity }}
                    </vs-td>
                    <vs-td>
                      {{ item.created_at | moment("DD/MM/YYYY") }}
                    </vs-td>
                    <vs-td>
                      {{ item.created_at.substr(-8) }}
                    </vs-td>
                    <vs-td>
                      {{ item.invoice_number }}
                    </vs-td>
                    <vs-td>
                      {{ item.type }}
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <el-dropdown @command="itemAction">
                        <i class="fa fa-cogs text-primary"></i>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="item.pdf_name != ''" :command="{action: 'pdf', upload_pdf: item.upload_pdf, name: item.pdf_name, id: item.id}" class="text-success">
                            <i class="fa fa-download"></i>
                            Descargar Pdf
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ action: 'edit', id: item.id }" class="text-success">
                            <i class="fa fa-edit"></i>
                            Editar
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ action: 'delete', payload: { id: item.id } }" class="text-danger">
                            <i class="fa fa-times"></i>
                            Eliminar
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>

            <div class="mt-4 text-center zatura-pagination" v-if="pageCount > 1">
              <vs-pagination :total="pageCount" v-model="page"></vs-pagination>
            </div>
          </div>

          <div class="col-md-12 text-center" v-if="!loading && items.length == 0">
            <p>No hay inventario.</p>
          </div>
      </div>
    </div>
  </div>

  <!-- modal new item -->
    <vs-popup title="Nuevo ingreso inventario" :active.sync="newItemModal">
      <div class="col-md-12" v-loading="loading" element-loading-text="Guardando por favor espere">
        <form @submit.prevent="storeItem()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Información inventario</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Proveedor</label>
                      <el-select placeholder="" v-model="item.provider" value-key="id" name="provider" v-validate="'required'" filterable class="form-control" popper-class="el-select-float">
                        <el-option
                          v-for="provider in providers"
                          :key="provider.id"
                          :label="provider.name"
                          :value="provider">
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('provider')" class="error">
                        {{ errors.first('provider') }}
                      </label>
                    </div>
                    <div class="form-group">
                        <label>Subir PDF del documento</label>
                        <div class="form-group">
                            <el-upload
                            ref="upload"
                            action="#"
                            :auto-upload="false"
                            :limit="1"
                            :on-change="pdfSelect"
                            :on-exceed="pdfExceed"
                            :on-remove="pdfRemove"
                            :file-list="fileList"
                            :multiple="false">
                            <el-button slot="trigger" size="small" type="primary">
                                <i class="fa fa-upload"></i>
                                PDF DOCUMENTO
                            </el-button>
                            </el-upload>
                        </div>
                        <label v-show="errors.has('file_key')" class="error">
                            {{ errors.first('file_key') }}
                        </label>
                    </div>

                  </div>

                  <div class="col-md-6">

                    <text-input
                      name="quantity"
                      :label="'Cantidad'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('quantity')"
                      v-model="item.quantity"
                      data-vv-as="Cantidad">
                    </text-input>
                  </div>

                  <div class="col-md-12 text-center p-t-20">
                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    <!-- end modal new item -->

  <!-- modal edit item -->
    <vs-popup :active.sync="editItemModal" title="Editar inventario">
      <div class="col-md-12" v-loading="loading" element-loading-text="Guardando por favor espere">
        <form @submit.prevent="updateItemProvider()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Información inventario</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Proveedor</label>
                      <el-select placeholder="" v-model="item.provider" value-key="id" name="provider" v-validate="'required'" filterable class="form-control" popper-class="el-select-float">
                        <el-option
                          v-for="provider in providers"
                          :key="provider.id"
                          :label="provider.name"
                          :value="provider">
                        </el-option>
                      </el-select>
                      <label v-show="errors.has('provider')" class="error">
                        {{ errors.first('provider') }}
                      </label>
                    </div>
                    <div v-if="item.pdf_name != ''" class="form-group">
                      <label>PDF subido</label>
                      <label>{{ item.pdf_name.replace(".pdf",item.id+".pdf")  }}</label>
                    </div>
                  </div>
                  <div class="col-md-6">

                    <text-input
                      name="quantity"
                      :label="'Cantidad'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('quantity')"
                      v-model="item.quantity"
                      data-vv-as="Cantidad">
                    </text-input>

                  </div>

                  <div class="col-md-12 text-center p-t-20">
                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    <!-- end modal edit item -->
</div>
</template>

<script>
import inventoriesService from '@/services/inventories.service.js';
import utilitiesService from '@/services/utilities.service';
import SearchFilter from '@/components/SearchFilter.vue';
import RegistersPerPage from '@/components/RegistersPerPage';
import helpers from '@/helpers/helpers';
//import { mapState, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
  name: 'items',
  data() {
    return {
      items: [],
      providers: [],
      loading: true,
      pageCount : 1,
      perPage: 10,
      page: 1,
      searchData: {},
      item: {
        item_id: "",
        provider_id: "",
        provider: "",
        quantity: "",
        pdf_file: null,
        upload_pdf: "",
        pdf_name: ""
      },
      provider: {
        id: "",
        company_id: "",
        name: "",
        description: ""
      },
      inventory: {
          id: "",
          company_id: "",
          item_id: "",
          quantity: ""
      },
      newItemModal: false,
      editItemModal: false,
      fileList: [],
    }
  },
  computed: {
    //...mapState(['providers']),
    categories() {
      return this.$store.state.providers;
    }
  },
  methods: {
    //...mapActions(['getProviders']),
    changeNumPerPage(num) {
      let searchData = this.searchData;
      searchData.perPage = num
      this.searchData = searchData
      this.getItemProviders(1, this.searchData)
    },
    search(search) {
      this.searchData = search;
      this.searchData.perPage = this.perPage
      this.getItemProviders(1, this.searchData)
    },
    getItemProviders(page = 1, search = {}) {
        let id = this.$route.params.id;
        this.item.item_id = id;
        /*this.$message({
              showClose: true,
              message: "id " + id,
              type: 'error'
            });*/
        inventoriesService.getItemProviders(id, page, search).then(res => {
            this.items = res.data.data
            console.log(res.data)
            this.loading = false;
            this.pageCount = res.data.last_page;
            inventoriesService.getInventory(id).then(inv => {
                console.log(inv.data.item)
                if (inv.data.item != null){
                    this.inventory = inv.data.item
                }
                else{
                    this.inventory.quantity = 0
                }
            }).catch(error1 => {
                this.loading = false;
                if(error1.response.status == 401) {
                }
            })
        }).catch(error => {
            this.loading = false;
            if(error.response.status == 401) {
            // localStorage.clear();
            // this.$router.push('login');
            }
        })
    },
    resetForm() {
      let data_form_initial = this.$options.data().item;
      Object.assign(this.$data.item, data_form_initial);
      this.$validator.reset();
    },
    newItem() {
      this.resetForm();
      this.newItemModal = true;
      //this.$router.push('new-item')
    },
    listAction(command) {
      switch(command.command) {
        case 'upload-pdf':
          utilitiesService.downloadFileByPath(command.payload.item.upload_xml)
          .then(response => {
            helpers.downloadBlob(response.data, `${command.payload.item.consecutive}.pdf`)
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error'
            });
          })
        break;
        //JRA Case para actualizar el documento
        case 'update-xml':
          this.resetForm();
          this.reception.type_update_doc = 'single'
          this.reception.id = command.payload.item.id;
          this.messageName = require('path').basename(command.payload.item.upload_xml);
          this.editMessageReceptorModal = true;
        break;
        case 'open-pdf':
          //let item = command.payload.item;
          //this.printNormal(item)

          utilitiesService.downloadFileByPath(command.payload.item.upload_pdf)
          .then(response => {
            let name = require('path').basename(command.payload.item.upload_pdf);
            console.log(name)
            helpers.downloadBlob(response.data, name)
          })
          .catch(error => {
              let name = require('path').basename(command.payload.item.upload_pdf);
            console.log(name)
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error'
            });
          })
        break;
      }
    },
    printNormal(item) {
      utilitiesService.getPdfAutomaticReception(item.id)
      .then(response => {
        helpers.downloadBlob(response.data, item.key50digits.substr(31, 10)+'.pdf');
      })
      .catch(error => {
        this.$message({
          showClose: true,
          message: 'Este archivo no esta disponible para su descarga',
          type: 'error'
        });
      })
    },
    pdfSelect(file) {
      this.fileList.push(file)
      this.item.pdf_file = file.raw
    },
    pdfExceed(file) {
      this.fileList = []
      this.fileList.push(file[0]);
      this.item.pdf_file = file[0];
    },
    pdfRemove() {
      this.fileList = [],
      this.item.pdf_file = null;
    },
    itemAction(command) {
      if(command.action == 'edit') {
        //this.$router.push({name: 'edit-item', params: {id: command.id} });
        this.resetForm();
        this.getItemProvider(command.id);
        this.editItemModal = true;
      } else if(command.action == 'pdf') {
          utilitiesService.downloadFileByPath(command.upload_pdf)
          .then(response => {
            //let name = require('path').basename(command.upload_pdf);
            //console.log(name)
            helpers.downloadBlob(response.data, command.name.replace(".pdf",command.id+".pdf"))
          })
          .catch(error => {
              let name = require('path').basename(command.upload_pdf);
            console.log(name)
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error'
            });
          })
      } else if(command.action == 'delete') {
         this.$confirm('¿ Deseas eliminar el ingreso de inventario ?', 'Eliminar Ingreso', {
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
            center: true
          }).then(() => {
            this.loading = true;
            let index = this.items.findIndex(i => i.id === command.payload.id);
            inventoriesService.deleteItemProvider(command.payload.id)
            .then(() => {
              this.loading = false;
              this.items.splice(index, 1);
              this.$message({
                type: 'success',
                message: 'Ingreso eliminado'
              });
            })
            .catch(() => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: 'Ocurrio un problema'
              });
            });
          }).catch(() => {
            this.loading = false;
            this.$message({
              type: 'info',
              message: 'Acción cancelada'
            });
          });
      }
    },
    goPage(numPage) {
      this.getItemProviders(numPage, this.searchData);
    },
    storeItem() {
      this.$validator.validate().then(valid => {
        if (valid) {
          //let data = this.item;
          let data = new FormData();
          this.loading = true;
          let id = this.$route.params.id;
          this.item.item_id = id;
          this.item.provider_id = this.item.provider.id;
          Object.keys(this.item).forEach(key => {
            let value;
            if(typeof this.item[key] === 'object' && !(this.item[key] instanceof File)) {
              value = JSON.stringify(this.item[key])
            } else {
              value = this.item[key]
            }
            data.append(key, value)
          });
          console.log(this.item)
          inventoriesService.storeItemProvider(data)
          .then(() => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: 'Ingreso Guardado correctamente',
              type: 'success',
              duration: 1500
            });
            this.getItemProviders(1, this.searchData);
            this.newItemModal = false;
          })
          .catch(function (error) {
            this.loading = false;
            this.$message({
              showClose: true,
              message: error.response.data.message,
              type: 'error'
            });
          });
        }
      });
    },
    getItemProvider(id) {
      inventoriesService.getItemProvider(id)
      .then((res) => {
        this.item = res.data.item;
      })
      .catch((error) => {
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      });
    },
    updateItemProvider() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loading = true;
          let data = this.item;
          inventoriesService.updateItemProvider(data)
          .then(() => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: 'Ingreso actualizado correctamente',
              type: 'success',
              duration: 1500
            });
            this.getItemProviders(1, this.searchData);
            this.editItemModal = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              duration: 1500
            });
          });
        }
      });
    },
    async getProviders(page = 0, search = {}) {
        try {
            const res = await inventoriesService.getProviders(page, search)
            this.providers = res.data
            console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }
  },
  watch: {
    page(newVal) {
      this.goPage(newVal);
    }
  },
  created() {
    this.getItemProviders();
    this.getProviders();
  },
  components: {
    SearchFilter,
    RegistersPerPage,
    Modal
  }
};
</script>

<style scope>

.box-shadow {
  box-shadow: 0 0 2px rgb(136, 124, 124) !important;
}

.oculto {
  display: none;
}

.con-vs-popup .vs-popup {
  width: 700px !important;
}

.el-select-dropdown__item {
  max-width: 600px;
  position: static;
  white-space: break-spaces;
  text-overflow: none;
  /* height: auto !important; */
  height: auto;
  max-height: 60px;
}
</style>
